import Reflux from "reflux";

export default Reflux.createActions([
  "userNotInterested",
  "undoUserNotInterested",
  "isFlashMessageForBook",
  "closeFlashMessage",
  "addBookIDToState",
]);
